export enum LeftBarOnlyIconsEnum {
  yes = 'yes',
  no = 'no',
}
